import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppNavbar from "@/components/layouts/AppNavbar.vue";
import AppFooter from "@/components/layouts/AppFooter.vue";
import WhatsappButton from "@/components/layouts/WhatsappButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppNavbar),
    _createVNode(_component_router_view),
    _createVNode(AppFooter),
    _createVNode(WhatsappButton)
  ], 64))
}
}

})